import React from "react";
import PropTypes from "prop-types";

const SetEmailInfo = ({ sendEmail, email, changeEmail, skipUrl }) => {
    return (
        <div id="setEmailInfo">
            <div className="form-title"><span className="label-blue-mail-icon"/>Verification Email Sent</div>

            <div className="linked-email">{email}</div>

            <div className="form-subtitle">Thanks for upgrading! We just sent you an email – click the link within to verify your email. This could take a few minutes. If you don’t see this email after 5-10 minutes:
            </div>

            <br/>
            <div className="form-subtitle">
                <ul>
                    <li>Check your Spam folder</li>
                    <li>Add @wolterskluwer.com domain to your safe list</li>
                    <li>Verify that your entered email address is correct</li>
                </ul>
            </div>

            <div className="row-link">
                <a className="link" name="resendEmail" onClick={() => sendEmail(email)}>Resend Email</a></div>
            { skipUrl &&
                <div className="row-link">
                    <a className="link" name='skipLink' href={skipUrl}>Log in now and Complete Verification Later</a>
                </div>
            }
            <div className="row-link last-row">
                <a className="link" name="changeEmail" onClick={changeEmail}>Change Email Address</a>
            </div>
        </div>
    );
};

SetEmailInfo.defaultProps = {
    email: "",
    skipUrl: ""
};

SetEmailInfo.propTypes = {
    sendEmail: PropTypes.func,
    changeEmail: PropTypes.func,
    email: PropTypes.string,
    skipUrl: PropTypes.string
};

export default SetEmailInfo;
